import React, { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { SlCheck } from 'react-icons/sl';
import { TiDeleteOutline } from 'react-icons/ti';
import { Image as AntImage } from 'antd';
import { MdDelete } from 'react-icons/md';

function ReportCard({
  label,
  imageUrl,
  qualityMetrics = [],
  isInReport = true,
  editMode,
  reportDetails,
  setReportDetails,
  plan,
  onCardDelete
}) {
  const [isQualOpen, setIsQualOpen] = useState(true);
  
  // Format quality metrics for display
  const formatQualityMetrics = (metrics) => {
    if (!metrics) return [];
    
    return Object.entries(metrics)
      .filter(([key]) => key.startsWith('QUAL_FLAG__'))
      .map(([key, value]) => ({
        title: key.replace('QUAL_FLAG__', '').replace(/_/g, ' '),
        bool: value
      }));
  };

  const quality_criteria = formatQualityMetrics(qualityMetrics);
  const onDelete = () => {
    const updatedReportDetails = { ...reportDetails };
    console.log('updatedReportDetails ::',updatedReportDetails)

    delete updatedReportDetails.images[plan];

    if (updatedReportDetails.report?.report_content?.[plan]) {
      updatedReportDetails.report.report_content[plan] = {};
    }
    if (updatedReportDetails.keys_info?.[plan]) {
      delete updatedReportDetails.keys_info[plan];
    }
    console.log('updatedReportDetails ::',updatedReportDetails)

    setReportDetails(updatedReportDetails);
    if (onCardDelete) {
        onCardDelete(plan);
      }
  };

  return (
    <>
      {isInReport && (
        <div
          className={`relative flex
            h-fit rounded-md border-2 border-[#A6ABC8] bg-black`}
        >
    <div className="group relative overflow-hidden w-full h-full flex items-center justify-center">
          <div className="flex h-full w-full items-center justify-center">
            <AntImage
              src={'data:image/jpeg;base64,'+imageUrl }
              alt={label}
              
              style={{
                width: quality_criteria?.length > 0 ? '100%' : '176px',
                height: quality_criteria?.length > 0 ? '100%' : '176px',
                transition: 'filter 0.3s ease',
              }}
              className={`mx-auto my-auto ${
                editMode ? 'group-hover:blur-sm' : ''
              }`}
              preview={{
                mask: editMode ? false : 'Click to view',
                maskClassName: 'rounded-md',
              }}
            />
            {editMode && (
                              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <button
                                  onClick={onDelete}
                                  className="bg-red-600/70 hover:bg-red-700/70 p-2 rounded-full flex items-center justify-center transform transition-transform duration-300 hover:scale-110"
                                  aria-label="Delete image"
                                >
                                  <MdDelete className="text-white text-xl" />
                                </button>
                              </div>
                            )}
          </div>
          </div>
          <div className="absolute top-2 left-2">
            <div className="flex w-full justify-start text-lg font-semibold text-white">
              {label}
            </div>
          </div>

          {quality_criteria?.length > 0 && (
            <>
              {!isQualOpen ? (
                <div className="absolute bottom-2 right-2 cursor-pointer text-white">
                  <IoIosArrowUp
                    size={20}
                    onClick={() => setIsQualOpen(!isQualOpen)}
                  />
                </div>
              ) : (
                <div className="absolute bottom-0 w-full bg-black py-3 px-2 text-white">
                  <div className="mb-1 flex items-center justify-between">
                    <div className="text-lg">Quality Criteria</div>
                    <IoIosArrowDown
                      size={20}
                      onClick={() => setIsQualOpen(!isQualOpen)}
                      className="cursor-pointer"
                    />
                  </div>

                  <div className="grid grid-cols-2 space-y-1">
                    {quality_criteria.map((item, i) => (
                      <div
                        key={i}
                        className="flex items-center justify-between pr-7 text-xs"
                      >
                        <div className="flex w-full justify-start">
                          {item?.title}
                        </div>
                        <div
                          className={`flex justify-end ${
                            item?.bool ? 'text-[#32CD32]' : 'text-[#FF4747]'
                          }`}
                        >
                          {item?.bool ? (
                            <SlCheck size={14} className="mr-0.5" />
                          ) : (
                            <TiDeleteOutline size={18} />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}

export default ReportCard;